import { useQuery } from '@tanstack/react-query';

import { QueryVariables, StaleTime } from 'queries/types';

import { transferByShareCodeQuery } from './queries';

export const useTransferByShareCode = (
  variables: QueryVariables<typeof transferByShareCodeQuery>,
  config?: Partial<ReturnType<typeof transferByShareCodeQuery>>,
) => {
  const { data, isError, isPending } = useQuery({
    ...transferByShareCodeQuery(variables),
    staleTime: StaleTime.FOREVER,
    enabled: !!variables.shareCode,
    retry: false,
    ...config,
  });

  return { transfer: data?.transferByShareCode, isError, isPending };
};
